<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Mobil cihazların qeydiyyat rüsumu</h1>
        <p>Azərbaycan Respublikası Nazirlər Kabinetinin 2018-ci il 31 iyul tarixli 336 nömrəli qərarı ilə təsdiq edilmiş, mobil cihazların qeydiyyata alınmasına görə 2018-ci il üçün dövlət rüsumunun məbləğləri: </p>
      </div>
      <div class="col-md-6">
        <p>Mobil cihazın qiymətini daxil edin (USD):</p>
        <input type="text" v-model="price" @input="getRusum">
      </div>
      <div class="col-md-6">
        <p>Ödəniləcək rüsum:</p>
        <input type="text" v-model="rusum" disabled>
      </div>
      <div class="col-md-12">
        <div class="note">
          <p>Dövlət rüsumunun məbləği:</p>
          <ul>
            <li>Foto, videoçəkiliş və internetə çıxış funksiyaları olmayan mobil cihazların
          qeydiyyata alınması - 20 AZN</li>
            <li>100 ABŞ dollarına qədər - 30 AZN</li>
            <li>101 ABŞ dollarından 200 ABŞ dollarına qədər - 50 AZN</li>
            <li>201 ABŞ dollarından 400 ABŞ dollarına qədər - 60 AZN</li>
            <li>401 ABŞ dollarından 700 ABŞ dollarına qədər - 70 AZN</li>
            <li>701 ABŞ dollarından 1 000 ABŞ dollarına qədər - 100 AZN</li>
            <li>1001 ABŞ dollarından yuxarı olduqda - 150 AZN</li>
          </ul>
        </div>
      </div>

      </div>
    </div>
  </div>
  
</template>

<script> 
  export default {
    data(){
      return {
        price: '',
        rusum: '20 AZN'
      }
    },
    methods: {
      getRusum: function(){
        if(this.price <= 100){
          this.rusum = '30 AZN'
        } else if(this.price <= 200){
          this.rusum = '50 AZN'
        } else if(this.price <= 400){
          this.rusum = '60 AZN'
        } else if(this.price <= 700){
          this.rusum = '70 AZN'
        } else if(this.price <= 1000){
          this.rusum = '100 AZN'
        } else {
          this.rusum = '150 AZN'
        }
      }
    }
  }
</script>

<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/calc/Imei.vue